import { render } from "./RegisterViaOTP.vue?vue&type=template&id=59c2b6b1"
import script from "./RegisterViaOTP.vue?vue&type=script&lang=js"
export * from "./RegisterViaOTP.vue?vue&type=script&lang=js"

import "./RegisterViaOTP.vue?vue&type=style&index=0&id=59c2b6b1&lang=css"

import exportComponent from "/var/www/zaytoon-mtn-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__